/**
 * 1단위 좌표로 만들고 그다음 실제 좌표 적용하기. 성공!
 */

import { Vue, Component } from 'vue-property-decorator';

import _ from 'lodash';
import rawData from '@/data/19983881105_e93c2d8279_b.jpg.json';
// import rawData from '@/data/img_237.jpg.json';
// import rawData from '@/data/img_348.jpg.json';

interface Node {
  Ind: number;
  Type: string;
  Lind: number;
  Rind: number;
  NumLeaves: number;
  R: number;
  G: number;
  B: number;
  Ward: number;
  Sse: number;
  Var: number;
  Std: number;
  NumClusterSamples: number;
  x: number | null; // 노드의 x 좌표
  y: number | null; // 노드의 y 좌표
  parentInd: number | null; // 부모 index
  depth: number | null; // root 노드로부터의 depth
  leftRightInfoList: string[]; // root 노드로 부터 왼쪽 자식인지, 오른쪽 자식인지. ['left', 'right', 'left', 'left']
  depthRowIndex: number; // 일정 depth에서의 왼쪽시작 기준으로 해당 node의 index
  unitX: number; // 부모노드와 자식노드의 가로 길이를 4단위로 만든 x좌표
}

interface NodesDict {
  [nodeId: number]: Node;
}

interface Edge {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

@Component({})
export default class Dendrogram extends Vue {
  private readonly xVariance: number = 2;
  private readonly nodeYInterval: number = 30;

  private nodes: Node[] = [];
  private edges: Edge[] = [];

  private created() {
    // nodes를 초기화한다.
    this.nodes = _.map(rawData, datum => {
      return {
        Ind: datum.Ind,
        Type: datum.Type,
        Lind: datum.Lind,
        Rind: datum.Rind,
        NumLeaves: datum.NumLeaves,
        R: datum.R,
        G: datum.G,
        B: datum.B,
        Ward: datum.Ward,
        Sse: datum.Sse,
        Var: datum.Var,
        Std: datum.Std,
        NumClusterSamples: datum.NumClusterSamples,
        x: null,
        y: null,
        parentInd: null,
        depth: null,
        leftRightInfoList: [],
        depthRowIndex: -1,
        unitX: -1
      };
    });

    let nodesDict: NodesDict = _.keyBy(this.nodes, node => node.Ind);

    // parent를 구한다.
    _.forEach(this.nodes, node => {
      if (nodesDict.hasOwnProperty(node.Lind)) {
        nodesDict[node.Lind].parentInd = node.Ind;
      }
      if (nodesDict.hasOwnProperty(node.Rind)) {
        nodesDict[node.Rind].parentInd = node.Ind;
      }
    });
    // root를 구한다.
    const rootNode: Node = _.filter(
      this.nodes,
      node => node.parentInd === null
    )[0];

    rootNode.unitX = 300;

    // 각 node마다 depth를 구한다.
    for (let i = 0; i < this.nodes.length; i++) {
      this.nodes[i] = this.makeNodeDepthAndLeftRightInfoList(
        this.nodes[i],
        nodesDict
      );
      this.nodes[i].depthRowIndex = this.makeXPositionIndex(this.nodes[i]);
    }

    const maxDepthNode: Node = _.maxBy(this.nodes, node => node.depth) as Node;
    const maxDepth: number = maxDepthNode.depth as number;

    // TODO 여기서부터 다시 좌표를 짜도록 한다.
    // leafNodes들만 찾아내 x, y좌표를 depthRowIndex의 기준으로 나열한다.

    nodesDict = _.keyBy(this.nodes, node => node.Ind);

    nodesDict = this.makeNodesPosition(nodesDict);

    for (let i = 0; i < this.nodes.length; i++) {
      this.nodes[i] = this.makeNodePosition(this.nodes[i], nodesDict);
    }

    // // node의 oneUnitX 좌표를 찾는다.
    // _.forEach(this.nodes, node => {
    //   // 부모를 통해 좌표를 찾는다 (부모도 좌표가 없으면 부모의 부모의 좌표를 찾는다.)
    //   nodesDict = this.makeUnitX(node, nodesDict);
    // });
    // nodesDict = this.makeNotOverlaped(nodesDict);
    // // 실제 x, y 좌표를 적용시킨다
    // nodesDict = this.makeNodesDictPosition(nodesDict, this.xVariance);
    // this.nodes = _.values(nodesDict);

    // edges를 만든다.
    _.forEach(this.nodes, node => {
      if (node.Lind !== 0) {
        this.edges.push({
          x1: node.x as number,
          y1: node.y as number,
          x2: nodesDict[node.Lind].x as number,
          y2: nodesDict[node.Lind].y as number
        });
      }
      if (node.Rind !== 0) {
        this.edges.push({
          x1: node.x as number,
          y1: node.y as number,
          x2: nodesDict[node.Rind].x as number,
          y2: nodesDict[node.Rind].y as number
        });
      }
    });

    // console.log('this.nodes', this.nodes);
    // console.log('this.edges', this.edges);
  }
  // 실제 좌표를 만든다.
  private makeNodesDictPosition(
    nodesDict: NodesDict,
    xVariance: number
  ): NodesDict {
    _.forEach(nodesDict, node => {
      node.x = node.unitX * xVariance;
      node.y = (node.depth as number) * 50 + 50;
    });

    return nodesDict;
  }

  private makeNodesPosition(nodesDict: NodesDict): NodesDict {
    const horizonInterval: number = 16;
    const sortedLeafNodes = _.chain(nodesDict)
      .filter(node => node.Type === 'leaf')
      .sortBy(node => -node.Ind)
      .value();

    console.log('sortedLeafNodes', sortedLeafNodes);
    // sorting이 제대로 안되었다. 이유는?
    // 아니다 된거 같다.

    _.forEach(sortedLeafNodes, (node, index) => {
      node.x = index * horizonInterval;
      node.y = 500;
    });

    for (let i = 0; i < this.nodes.length; i++) {
      this.nodes[i] = this.makeNodePosition(this.nodes[i], nodesDict);
    }
    return nodesDict;
  }

  private makeNodePosition(node: Node, nodesDict: NodesDict): Node {
    if (node.Type !== 'leaf') {
      let leftChild = nodesDict[node.Lind];
      if (leftChild.x === null || leftChild.y === null) {
        leftChild = this.makeNodePosition(leftChild, nodesDict);
      }
      let rightChild = nodesDict[node.Rind];
      if (rightChild.x === null || rightChild.y === null) {
        rightChild = this.makeNodePosition(rightChild, nodesDict);
      }
      node.x = ((rightChild.x as number) - (leftChild.x as number)) / 2;
      node.y = (leftChild.y as number) - 50;
    }

    return node;
  }

  private makeXPositionIndex(node: Node): number {
    let xPositionIndex: number = 0;
    _.forEach(node.leftRightInfoList, (info, index) => {
      if (index < node.leftRightInfoList.length - 1) {
        if (info === 'right') {
          xPositionIndex += Math.pow(
            2,
            node.leftRightInfoList.length - 1 - index
          );
        }
      } else {
        if (info === 'right') {
          xPositionIndex += 1;
        }
      }
    });

    return xPositionIndex;
  }

  /**
   * node들이 겹치지 않게 만드는 함수
   * @param nodesDict
   */
  private makeNotOverlaped(nodesDict: NodesDict): NodesDict {
    let nodesDictVariable = nodesDict;

    let testIndex: number = 0;
    while (testIndex < 10000) {
      const dislocatedPositionNodes = this.findDislocatedPositionNodes(
        nodesDictVariable
      );

      if (dislocatedPositionNodes.length !== 0) {
        const sameParentNode = this.findSameAncestorNode(
          dislocatedPositionNodes[0],
          dislocatedPositionNodes[1],
          nodesDictVariable
        );

        // sameParentNode를 기준으로 왼쪽 오른쪽 이동시킨다.
        nodesDictVariable = this.moveSelfAndDescendants(
          nodesDictVariable[sameParentNode.Rind],
          nodesDictVariable,
          4
        );
        nodesDictVariable = this.moveSelfAndDescendants(
          nodesDictVariable[sameParentNode.Lind],
          nodesDictVariable,
          -4
        );
      } else {
        console.log('break');
        break;
      }
      testIndex++;
    }

    testIndex = 0;
    while (testIndex < 10000) {
      const smallGapPositionNodes: Node[] = this.findSmallGapPositionNodes(
        nodesDictVariable,
        8
      );

      if (smallGapPositionNodes.length !== 0) {
        const sameParentNode = this.findSameAncestorNode(
          smallGapPositionNodes[0],
          smallGapPositionNodes[1],
          nodesDictVariable
        );

        nodesDictVariable = this.moveSelfAndDescendants(
          nodesDictVariable[sameParentNode.Rind],
          nodesDictVariable,
          1
        );
        nodesDictVariable = this.moveSelfAndDescendants(
          nodesDictVariable[sameParentNode.Lind],
          nodesDictVariable,
          -1
        );
      } else {
        console.log('break2');
        break;
      }

      testIndex++;
    }

    return nodesDictVariable;
  }
  private findSmallGapPositionNodes(nodesDict: NodesDict, gap: number): Node[] {
    const smallGapPositionNodes: Node[] = [];

    const keys: string[] = Object.keys(nodesDict);

    for (let i = 0; i < keys.length - 1; i++) {
      for (let j = i + 1; j < keys.length; j++) {
        const node1: Node = nodesDict[keys[i]];
        const node2: Node = nodesDict[keys[j]];
        if (node1.depth === node2.depth) {
          if (
            (node1.depthRowIndex < node2.depthRowIndex &&
              (node2.unitX as number) - (node1.unitX as number) < gap) ||
            (node1.depthRowIndex > node2.depthRowIndex &&
              (node1.unitX as number) - (node2.unitX as number) < gap)
          ) {
            // console.log('!@#');
            smallGapPositionNodes.push(node1);
            smallGapPositionNodes.push(node2);
          }
        }
      }
    }

    return smallGapPositionNodes;
  }

  /**
   * 자신과 자손들을 오른쪽으로 이동하는 함수
   * @param node
   * @param nodesDict
   */
  private moveSelfAndDescendants(
    node: Node,
    nodesDict: NodesDict,
    variance: number
  ): NodesDict {
    let nodesDictVariable = nodesDict;
    const nodeVaiable = nodesDictVariable[node.Ind];

    nodeVaiable.unitX += variance;

    // 자식들이 null이 아닌 경우에는 계속 탐색한다.
    if (nodeVaiable.Rind !== 0) {
      nodesDictVariable = this.moveSelfAndDescendants(
        nodesDictVariable[nodeVaiable.Rind],
        nodesDictVariable,
        variance
      );
    }
    if (nodeVaiable.Lind !== 0) {
      nodesDictVariable = this.moveSelfAndDescendants(
        nodesDictVariable[nodeVaiable.Lind],
        nodesDictVariable,
        variance
      );
    }

    return nodesDictVariable;
  }

  /**
   * 두 노드의 가장 가까운 조상 노드를 찾는다.
   * @param node1
   * @param node2
   */
  private findSameAncestorNode(node1: Node, node2: Node, nodesDict: NodesDict) {
    let sameAncestorNode!: Node;
    let currentNode1: Node = node1;
    let currentNode2: Node = node2;
    while (true) {
      if (currentNode1.parentInd === currentNode2.parentInd) {
        if (currentNode1.parentInd === null) {
          sameAncestorNode = currentNode1;
        } else {
          sameAncestorNode = nodesDict[currentNode1.parentInd];
        }
        break;
      } else {
        // node들이 다른경우 다시 탐색한다.
        currentNode1 = nodesDict[currentNode1.parentInd as number];
        currentNode2 = nodesDict[currentNode2.parentInd as number];
      }
    }

    return sameAncestorNode;
  }

  /**
   * 같은 depth의 node들 간에 위치가 안맞는 경우 node를 반환하는 함수
   * @param nodesDict
   */
  private findDislocatedPositionNodes(nodesDict: NodesDict) {
    const dislocatedPositionNodes: Node[] = [];

    const keys: string[] = Object.keys(nodesDict);

    for (let i = 0; i < keys.length - 1; i++) {
      for (let j = i + 1; j < keys.length; j++) {
        const node1: Node = nodesDict[keys[i]];
        const node2: Node = nodesDict[keys[j]];

        if (node1.depth === node2.depth) {
          if (
            (node1.depthRowIndex < node2.depthRowIndex &&
              (node1.unitX as number) >= (node2.unitX as number)) ||
            (node1.depthRowIndex > node2.depthRowIndex &&
              (node1.unitX as number) <= (node2.unitX as number))
          ) {
            dislocatedPositionNodes.push(node1);
            dislocatedPositionNodes.push(node2);
          }
        }
      }
    }

    return dislocatedPositionNodes;
  }

  private findDepth(node: Node, nodesDict: NodesDict): number {
    let depth: number = 0;
    let currentNode: Node = node;

    while (currentNode.parentInd !== null) {
      depth += 1;
      currentNode = nodesDict[currentNode.parentInd];
    }

    return depth;
  }

  private makeNodeDepthAndLeftRightInfoList(
    node: Node,
    nodesDict: NodesDict
  ): Node {
    let currentNode: Node = node;
    let depth: number = 0;
    const leftRightInfoList: string[] = [];

    while (currentNode.parentInd !== null) {
      depth += 1;
      const parentNode: Node = nodesDict[currentNode.parentInd];

      if (currentNode.Ind === parentNode.Lind) {
        leftRightInfoList.unshift('left');
      } else if (currentNode.Ind === parentNode.Rind) {
        leftRightInfoList.unshift('right');
      }

      currentNode = parentNode;
    }

    node.depth = depth;
    node.leftRightInfoList = leftRightInfoList;

    return node;
  }

  /**
   * 자식들 중 가장 깊은 depth를 반환하는 함수
   * @param node
   * @param nodesDict
   */
  private findChildMaxDepth(node: Node, nodesDict: NodesDict): number {
    let leftChildDepth: number = node.depth as number;
    let rightChildDepth: number = node.depth as number;
    if (node.Lind !== 0) {
      leftChildDepth = this.findChildMaxDepth(nodesDict[node.Lind], nodesDict);
    }
    if (node.Rind !== 0) {
      rightChildDepth = this.findChildMaxDepth(nodesDict[node.Rind], nodesDict);
    }

    return leftChildDepth >= rightChildDepth ? leftChildDepth : rightChildDepth;
  }

  /**
   * 해당 node와 그 부모들의 node에 unitX 좌표를 형성한 nodesDict를 반환하는 함수이다.
   */
  private makeUnitX(node: Node, nodesDict: NodesDict): NodesDict {
    if (node.parentInd !== null) {
      // 부모 node에 대한 oneUnitX를 먼저 구한다
      let parentNode = nodesDict[node.parentInd];
      if (parentNode.x === null || parentNode.y === null) {
        nodesDict = this.makeUnitX(parentNode, nodesDict);
      }
      parentNode = nodesDict[node.parentInd];

      // parent의 왼쪽자식인지 오른쪽자식인지 알아야 한다.
      if (node.Ind === parentNode.Lind) {
        node.unitX = parentNode.unitX - 4;
      } else if (node.Ind === parentNode.Rind) {
        node.unitX = parentNode.unitX + 4;
      }

      nodesDict[node.Ind] = node;
    }

    return nodesDict;
  }

  private fillNodeTextColor(node: Node) {
    // if (node.Ind === 7 || node.Ind === 11 || node.Ind === 238) {
    //   return 'rgb(0, 0, 255)';
    // } else {
    //   return 'rgba(0, 0, 0, 0)';
    // }

    return 'rgba(0, 0, 0, 1)';
  }

  private mounted() {
    //
  }
}
